import { render, staticRenderFns } from "./IfElse.vue?vue&type=template&id=4e0f0b3a&scoped=true"
import script from "./IfElse.vue?vue&type=script&lang=js"
export * from "./IfElse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0f0b3a",
  null
  
)

export default component.exports